import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class OrganizationSettingsService {
  admissionNumberLabel = 'Admission No';
  isFacialRecognitionMode = false;

  setAdmissionNumberLabel(value: unknown): void {
    const label = typeof value === 'string' ? value.trim() : '';
    this.admissionNumberLabel = label && label.toLowerCase() !== 'default'
      ? label
      : 'Admission No';
  }

  setFaceAuthDeviceSettings(value: unknown): void {
    this.isFacialRecognitionMode = Array.isArray(value) && value.some((device: any) =>
      typeof device?.imei === 'string' && device.imei.trim().length > 0
    );
  }
}
